// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import * as React from "react";

const Description: React.FC = () => {
    return <svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 34 42" enableBackground="new 0 0 34 42" xmlSpace="preserve">
<path fillRule="evenodd" clipRule="evenodd" d="M21.17,0.17H4.5c-2.29,0-4.15,1.88-4.15,4.17L0.33,37.67
	c0,2.29,1.85,4.17,4.15,4.17H29.5c2.29,0,4.17-1.88,4.17-4.17v-25L21.17,0.17z M25.33,33.5H8.67v-4.17h16.67V33.5z M25.33,25.17
	H8.67V21h16.67V25.17z M19.08,14.75V3.29l11.46,11.46H19.08z"/>
</svg>;
};

export default React.memo(Description);
